import { defineFilterSpec, enumField, text } from '@/lib/api/filter-spec';

import type { CustomerDeviceFilterFormValues, CustomerDeviceFilters } from './types';

/** Devices tab filter serialization (drawer draft <-> applied <-> query), shared by the drawer,
 *  the list api, and the page/export. `category` matches by NAME — there is no master Category
 *  endpoint, and the backend's own `GetCustomerDevicesDto.category` param takes names, not ids.
 *  There is no `deviceName` filter param on this tab; the search box already covers Device Name. */
const spec = defineFilterSpec<CustomerDeviceFilters, CustomerDeviceFilterFormValues>([
  text('search'),
  enumField('category'),
  // Wire param `deviceType`, comma-separated on the backend (`GetCustomerDevicesDto`'s
  // `toStringArray` + `@IsEnum(DeviceType, { each: true })`). `enumField` sends the single value
  // the AC's "(dropdown)" asks for, which that transform accepts — the Subscription tab already
  // does exactly this (ADO 119225).
  enumField('deviceType'),
  enumField('deviceStatus'),
  // Wire param `connectorStatus`, comma-separated on the backend (`customer-devices.repository.ts`
  // takes it as an array). `enumField` sends the single value story 113560's "(dropdown)" asks
  // for, exactly as `deviceType` above already does.
  enumField('connectorStatus'),
  enumField('subscriptionStatus'),
]);

export const customerDeviceToListQuery = spec.toListQuery;
export const customerDeviceToDefaults = spec.toDefaults;
export const customerDeviceToFilters = spec.toFilters;
export const customerDeviceHasActiveFilters = spec.hasActiveFilters;
